import axios from 'axios';
import imageCompression from 'browser-image-compression';

import querystring from 'querystring';
// import { getAuthToken } from '@/storage/local';
const DEBUG = import.meta.env.DEV;
class Client {
  static async getTokenHeader() {
    return { 'x-access-token': localStorage.getItem('token') };
  }
  static async getHeaders(isAuth, contentType = 'application/json') {
    const headers = {
      'Content-Type': contentType,
    };
    if (isAuth) {
      const token = await localStorage.getItem('token');
      // headers['Authorization'] = `Bearer ${token}`;
      headers['x-access-token'] = token;
    }
    return headers;
  }
  static async request(config) {
    let response;
    try {
      response = await axios(config);
    } catch (e) {
      if (e.response && e.response.status === 401 && (e.response.data.message === 'jwt expired' || e.response.data === 'UN_AUTHORIZED_ADMIN_IP')) {
        window.location.reload();
      }
      console.log(e);
      return {
        success: false,
        err: e,
      };
    }
    if (!response || !response.data) {
      return {
        success: false,
        err: 'no response data',
      };
    }
    if (DEBUG) {
      console.log(response.data);
    }
    return response.data;
  }
  static async send(method, url, data, isAuth) {
    if (DEBUG) {
      console.log(`[${method}]${url}`);
      if (data) {
        console.log(data);
      }
    }
    const config = {
      method: method,
      url: url,
      headers: await this.getHeaders(isAuth),
    };
    switch (method) {
      case 'get':
        config.params = data;
        break;
      case 'post':
      case 'put':
      case 'delete':
      case 'patch':
        config.data = data;
        break;
      default:
    }
    return await Client.request(config);
  }
  static async get(url, params, isAuth) {
    return await this.send('get', url, params, isAuth);
  }
  static async post(url, data, isAuth) {
    return await this.send('post', url, data, isAuth);
  }
  static async put(url, data, isAuth) {
    return await this.send('put', url, data, isAuth);
  }
  static async delete(url, data, isAuth) {
    return await this.send('delete', url, data, isAuth);
  }
  static async patch(url, data, isAuth) {
    return await this.send('patch', url, data, isAuth);
  }
  static async uploadFileWithoutCompress(url, key, file, onProgress) {
    if (DEBUG) {
      console.log(file);
    }
    const data = new FormData();

    let encodedFileName = encodeURIComponent(file.name.normalize('NFC').replace(/[^a-zA-Z0-9가-힣à-ỹ.]/g, '_'));
    const renamedFile = new File([file], encodedFileName, { type: file.type });
    data.append(key, renamedFile);

    const config = {
      method: 'post',
      url,
      data,
      headers: await this.getHeaders(true, 'multipart/form-data'),
      onUploadProgress: progress => {
        if (onProgress) {
          onProgress(progress);
        }
      },
    };
    return await Client.request(config);
  }
  static async uploadFile(url, key, file, onProgress) {
    if (DEBUG) {
      console.log(file);
    }
    const data = new FormData();

    let encodedFileName = encodeURIComponent(file.name.normalize('NFC').replace(/[^a-zA-Z0-9가-힣à-ỹ.]/g, '_'));
    const renamedFile = new File([file], encodedFileName, { type: file.type });
    data.append(key, renamedFile);

    const config = {
      method: 'post',
      url,
      data,
      headers: await this.getHeaders(true, 'multipart/form-data'),
      onUploadProgress: progress => {
        if (onProgress) {
          onProgress(progress);
        }
      },
    };
    return await Client.request(config);
  }

  static async uploadFileWithoutAuth(url, key, file, onProgress) {
    if (DEBUG) {
      console.log(file);
    }
    const data = new FormData();

    let encodedFileName = encodeURIComponent(file.name.normalize('NFC').replace(/[^a-zA-Z0-9가-힣à-ỹ.]/g, '_'));
    const renamedFile = new File([file], encodedFileName, { type: file.type });
    data.append(key, renamedFile);

    const config = {
      method: 'post',
      url,
      data,
      headers: await this.getHeaders(false, 'multipart/form-data'),
      onUploadProgress: progress => {
        if (onProgress) {
          onProgress(progress);
        }
      },
    };
    return await Client.request(config);
  }

  static async uploadFileV2(url, type, file, onProgress, signal = null) {
    if (DEBUG) {
      console.log(file);
    }
    const data = new FormData();

    let encodedFileName = encodeURIComponent(file.name.normalize('NFC').replace(/[^a-zA-Z0-9가-힣à-ỹ.]/g, '_'));
    const renamedFile = new File([file], encodedFileName, { type: file.type });
    data.append('file', renamedFile);
    data.append('type', type);

    const config = {
      method: 'post',
      url,
      data,
      ...(signal && { signal }),
      headers: await this.getHeaders(true, 'multipart/form-data'),
      onUploadProgress: progress => {
        if (onProgress) {
          onProgress(progress);
        }
      },
    };
    return await Client.request(config);
  }
  // static async uploadFile(url, key, file, onProgress) {
  //   if (DEBUG) {
  //     // console.log([Upload]${url});
  //     console.log(file);
  //   }
  //   // const fileName = file.path.replace(/^.*[\\\/]/, '');
  //   // const data = new FormData();

  //   // data.append(key, {
  //   //   uri: file.path,
  //   //   name: fileName,
  //   //   type: file.mime,
  //   // });

  //   //file compression
  //   const compressedBlob = await imageCompression(file, { maxSizeMB: 1 });
  //   const compressedFile = new File([compressedBlob], compressedBlob.name, { type: compressedBlob.type });

  //   //image
  //   const data = new FormData();
  //   data.append(key, compressedFile);

  //   const config = {
  //     method: 'post',
  //     url,
  //     data,
  //     headers: await this.getHeaders(true, 'multipart/form-data'),
  //     onUploadProgress: progress => {
  //       if (onProgress) {
  //         onProgress(progress);
  //       }
  //     },
  //   };
  //   return await Client.request(config);
  // }

  static async downLoadFile(url, data, isAuth, fileName) {
    if (DEBUG) {
      if (data) {
        console.log(data);
      }
    }
    const config = {
      method: 'get',
      url: url,
      headers: await this.getHeaders(isAuth),
      params: data,
      responseType: 'blob',
    };
    let response;
    try {
      response = await axios(config);
    } catch (e) {
      console.log(e);
      return {
        success: false,
        err: e,
      };
    }
    if (!response || !response.data) {
      return {
        success: false,
        err: 'no response data',
      };
    }
    if (DEBUG) {
      console.log(response.data);
    }
    const _url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = _url;
    if (fileName) {
      link.setAttribute('download', `${fileName}`);
    } else {
      // 서버에서 파일명을 Content-Disposition 헤더로 전달하는 경우 처리
      const disposition = response.headers && (response.headers['content-disposition'] || response.headers['Content-Disposition']);
      let serverFileName = 'downloaded_file';

      if (disposition) {
        // filename*=UTF-8'' 형식 처리 (RFC 5987)
        const filenameStarMatch = disposition.match(/filename\*=UTF-8''([^;]+)/);
        if (filenameStarMatch && filenameStarMatch[1]) {
          serverFileName = decodeURIComponent(filenameStarMatch[1]);
        } else {
          // 기존 filename= 형식 처리
          const filenameMatch = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          if (filenameMatch && filenameMatch[1]) {
            serverFileName = decodeURIComponent(filenameMatch[1].replace(/['"]/g, ''));
          }
        }
      }

      if (DEBUG) {
        console.log('Final filename:', serverFileName);
      }

      link.setAttribute('download', serverFileName);
    }
    document.body.appendChild(link);
    link.click();
    return response.data;
  }

  static async downLoadFileByPost(url, data, isAuth, fileName) {
    if (DEBUG) {
      if (data) {
        console.log(data);
      }
    }
    const config = {
      method: 'post',
      url: url,
      headers: await this.getHeaders(isAuth),
      data: data,
      responseType: 'blob',
    };
    let response;
    try {
      response = await axios(config);
    } catch (e) {
      console.log(e);
      return {
        success: false,
        err: e,
      };
    }
    if (!response || !response.data) {
      return {
        success: false,
        err: 'no response data',
      };
    }
    if (DEBUG) {
      console.log(response.data);
    }
    const _url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = _url;
    if (fileName) {
      link.setAttribute('download', `${fileName}`);
    } else {
      // 서버에서 파일명을 Content-Disposition 헤더로 전달하는 경우 처리
      const disposition = response.headers && (response.headers['content-disposition'] || response.headers['Content-Disposition']);
      let serverFileName = 'downloaded_file';

      if (disposition) {
        // filename*=UTF-8'' 형식 처리 (RFC 5987)
        const filenameStarMatch = disposition.match(/filename\*=UTF-8''([^;]+)/);
        if (filenameStarMatch && filenameStarMatch[1]) {
          serverFileName = decodeURIComponent(filenameStarMatch[1]);
        } else {
          // 기존 filename= 형식 처리
          const filenameMatch = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          if (filenameMatch && filenameMatch[1]) {
            serverFileName = decodeURIComponent(filenameMatch[1].replace(/['"]/g, ''));
          }
        }
      }

      if (DEBUG) {
        console.log('Final filename:', serverFileName);
      }

      link.setAttribute('download', serverFileName);
    }
    document.body.appendChild(link);
    link.click();
    return response.data;
  }
}
export default Client;
